// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CustomAppState } from "@guestsupply/App/Store/Reducers";
import { xScreen } from "@guestsupply/XDL/Utilities";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import * as React from "react";
import { css } from "styled-components";

const enum fields {
    desktopMarginTop = "desktopMarginTop",
    tabletMarginTop = "tabletMarginTop",
    mobileMarginTop = "mobileMarginTop",
}

interface Props extends WidgetProps {
    fields: {
        [fields.desktopMarginTop]: number;
        [fields.tabletMarginTop]: number;
        [fields.mobileMarginTop]: number;
    };
}

const Spacer: React.FC<Props> = ({ fields }) => {
    const styles = {
        css: css`
            margin-top: ${fields.desktopMarginTop};
            ${xScreen("lte", "md")} {
                margin-top: ${fields.tabletMarginTop};
            }
            ${xScreen("lte", "xs")} {
                margin-top: ${fields.mobileMarginTop};
            }
        `,
    };

    return <StyledWrapper {...styles}></StyledWrapper>;
};

const widgetModule: WidgetModule = {
    component: Spacer,
    definition: {
        displayName: "Spacer",
        group: "Common",
        fieldDefinitions: [
            {
                name: fields.desktopMarginTop,
                displayName: "Desktop Margin Top",
                editorTemplate: "TextField",
                defaultValue: "10px",
                fieldType: "General",
            },
            {
                name: fields.tabletMarginTop,
                displayName: "Tablet Margin Top",
                editorTemplate: "TextField",
                defaultValue: "10px",
                fieldType: "General",
            },
            {
                name: fields.mobileMarginTop,
                displayName: "Mobile Margin Top",
                editorTemplate: "TextField",
                defaultValue: "10px",
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
